"use strict";

exports.__esModule = true;
exports.setStorageData = exports.removeStorageData = exports.getStorageDataByPartialKeys = exports.getStorageData = exports.default = void 0;

var _browser = require("~/utils/browser");

const getStorageData = key => {
  if (!(0, _browser.isBrowser)()) return null;
  const data = localStorage.getItem(key);

  try {
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error(`Error parsing JSON for key "${key}":`, error);
    return null;
  }
};

exports.getStorageData = getStorageData;

const getStorageDataByPartialKeys = ({
  startsWith,
  endsWith
}) => {
  if (!(0, _browser.isBrowser)()) {
    return null;
  }

  const keys = Object.keys(localStorage);
  const matchingKey = keys.find(key => {
    if (startsWith && endsWith) {
      return key.startsWith(startsWith) && key.endsWith(endsWith);
    }

    if (startsWith) {
      return key.startsWith(startsWith);
    }

    if (endsWith) {
      return key.endsWith(endsWith);
    }

    return false;
  });
  const item = matchingKey ? localStorage.getItem(matchingKey) : null;
  return item ? JSON.parse(item) : null;
};

exports.getStorageDataByPartialKeys = getStorageDataByPartialKeys;

const setStorageData = (key, value) => {
  if ((0, _browser.isBrowser)()) localStorage.setItem(key, JSON.stringify(value));
};

exports.setStorageData = setStorageData;

const removeStorageData = key => localStorage.removeItem(key);

exports.removeStorageData = removeStorageData;
var _default = {
  getStorageData,
  setStorageData,
  removeStorageData
};
exports.default = _default;